import surveyAnalysisReducer from "containers/DashboardContainer/Overview/SurveyAnalysisPage/store/SurveyAnalysis.reducer";

export default surveyAnalysisReducer;
